export default "__VITE_ASSET__BSlX$ik7__"